import React, {Component} from "react";
import Paper from '@material-ui/core/Paper';
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import NewWindow from 'react-new-window'

import {format, parseISO} from "date-fns";
import ReactHlsPlayer from "react-hls-player";
import LivePlayer from "./LivePlayer";

const classes = makeStyles({
    table: {
        minWidth: 655,

    },
});

function round(value, decimals) {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

function getResultColor(result) {
    if (result === "STARTED") {
        return "#09badd"
    } else if (result === "ONROUTE") {
        return "#b49f40"
    } else if (result === "ABORTED") {
        return "#d61c02"
    } else if (result === "COMPLETED"){
        return "#028d41"
    } else {
        return "#FFF"
    }
}



class LiveTable extends Component {

    state = {
        page: 0,
        rowsPerPage: 4
    }

    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });

    };


    render() {

        console.log("drones: ", this.props.dronesLive);
        console.log("dronesSubscribed: ", this.props.dronesSubscribed);
        console.log("droneStatuses: ", this.props.droneStatuses);
        const {
            dronesLive
        } = this.props
        return (
            <Paper>
                <TableContainer>
                    <Table   className={classes.table} size="small" aria-label="a dense table">
                        <TableHead >
                            <TableRow>
                                <TableCell style={{fontSize: '0.7rem', padding: 0}} align="center">Canonical Name</TableCell>
                                <TableCell style={{fontSize: '0.7rem', padding: 0}} align="center">Altitude</TableCell>
                                <TableCell style={{fontSize: '0.7rem', padding: 0}} align="center">Heading</TableCell>
                                {/*<TableCell align="center">Gimbal Pitch</TableCell>*/}
                                <TableCell style={{fontSize: '0.7rem', padding: 0}} align="center">Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(dronesLive).slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map(canonicalName => (
                                <TableRow
                                    // style={{backgroundColor: mouseOverTelecomRequestPolygonId === row.id ? "#A0A0A0" : "#FFF"}}
                                    >
                                    <TableCell style={{fontSize: '0.7rem', padding: 0}} component="th" scope="row">
                                        {canonicalName}
                                    </TableCell>
                                    <TableCell style={{fontSize: '0.7rem', padding: 0}}
                                        align="center">{round(dronesLive[canonicalName].altitude, 1)}</TableCell>
                                    <TableCell style={{fontSize: '0.7rem', padding: 0}} align="center">{dronesLive[canonicalName].heading}</TableCell>
                                    <TableCell style={{backgroundColor: getResultColor(this.props.droneStatuses[canonicalName]), fontSize: '0.7rem', padding: 0}}
                                               align="center">
                                        <span style={{color: "#FFF"}}>{this.props.droneStatuses[canonicalName]}</span>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </TableContainer>
            </Paper>
        )
    }
}

export default LiveTable;
